import {useEffect, useContext} from 'react';
import marketingParametersService from '../../../services/restServices/marketingParametersService';
import {AppContext} from '../../../AppModule/Context';
import utilService from '../../../services/utilsService';
import VIDABOO_CONSTANTS from '../../../config/consts';

const UpdateMarketingParamsComponent = (props) => {
  const context = useContext(AppContext);

  useEffect(() => {
    const params = {...props.params};
    params.param = props.action;
    // need to be triggered if:
    // 1. in widget and this is a USER_INSTALLED_PLUGIN_ON_WEBSITE
    // 2. On backoffice and this is either a singleUser or accountUser which is accountManager. In this case, trigger USED_CALL and USED_CHAT
    if (
      ((utilService.getIsInWidget() &&
        props.action ===
          VIDABOO_CONSTANTS.MARKETING_EVENT_TYPES
            .USER_INSTALLED_PLUGIN_ON_WEBSITE) ||
        (utilService.getIsInExpertHome() && context.isAccountManager)) && // No account users.
      utilService.handleMarketingParametersServiceRequest(props.action)
    ) {
      if (
        props.action ===
          VIDABOO_CONSTANTS.MARKETING_EVENT_TYPES.USER_USED_CALL ||
        props.action === VIDABOO_CONSTANTS.MARKETING_EVENT_TYPES.USER_USED_CHAT
      )
        params.email = context.getCurrentUser().email;

      marketingParametersService.updateMarketingParameters(
        'PERSONAL',
        context.getCurrentUser().userId,
        params,
      );
      // only if successful, need to save in localStorage that we will not send next time.
    }
  }, []); // eslint-disable-line
  return null;
};

export default UpdateMarketingParamsComponent;
